<template>
  <div class="trustpilot-stars" :style="containerStyle">
    <svg
      v-for="i in 5"
      :key="i"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
    >
      <rect
        x="0"
        y="0"
        width="24"
        height="24"
        :fill="i <= count ? '#00b67a' : '#dcdce6'"
      />
      <path
        d="M12 4.5l1.96 5.9 6.2.05-5 3.62 1.88 5.93L12 16.4l-5.04 3.6L8.84 14.07l-5-3.62 6.2-.05L12 4.5z"
        fill="#fff"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'TrustpilotStars',
  props: {
    count: {
      type: Number,
      default: 5,
    },
    size: {
      type: Number,
      default: 22,
    },
    spacing: {
      type: Number,
      default: 2,
    },
  },
  computed: {
    containerStyle() {
      return {
        gap: `${this.spacing}px`,
      };
    },
  },
};
</script>
